import React, { useState } from 'react'
import { Typography, Button, TextField, Grid, Card, CardContent } from '@mui/material'
import { useDispatch } from 'react-redux'
import { sendForgotPassword } from '../actions/resetPassword'

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('')

  const dispatch = useDispatch()

  const handleSubmit = (e) => {
    e.preventDefault()

    dispatch(sendForgotPassword(email))
  }

  return (
    <div className='container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Card style={{ width: '70%' }}>
        <CardContent>
          <form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <Typography
                  style={{ textTransform: 'uppercase', fontWeight: '500' }}
                  variant="h4"
                >
                  Quên mật khẩu
                </Typography>
              </Grid>

              <Grid item style={{
                width: '50%'
              }}>
                <TextField
                  id="email"
                  label="Nhập email dùng để đặt lại mật khẩu"
                  type="text"
                  fullWidth
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                  }}
                />
              </Grid>

              <Grid item>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ color: 'white' }}
                  disableRipple
                >
                  Gửi email
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </div >
  );
}

export default ForgotPasswordScreen
